/**
* @prop --uic-charts-data-group-color: color of a specific data group, set it inside of the datagroups css class.
* @prop --uic-charts-donut-chart-general-font-size: line chart base text font size
* @prop --uic-charts-donut-chart-text-color: line chart text color (labels, tooltip etc.)
* @prop --uic-charts-donut-chart-percentage-label-font-weight: percentage label font weight
* @prop --uic-charts-donut-chart-percentage-label-font-size: percentage label font size
* @prop --uic-charts-donut-chart-group-label-font-weight: data group label font weight
* @prop --uic-charts-donut-chart-group-label-font-size: data group label font size
* @prop --uic-charts-donut-chart-icon-label-size: size of data group icon
* @prop --uic-charts-donut-chart-loading-overlay-color: color of the loading overlay
*/

uic-donut-chart {
    display: block;
    width: 100%;
    height: 100%;
}

.uic-donut-chart {
    font-size: var(--uic-charts-donut-chart-general-font-size);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: var(--uic-charts-donut-chart-text-color, black);

    &__label-percentage {
        font-weight: var(
            --uic-charts-donut-chart-percentage-label-font-weight,
            bold
        );
        font-size: var(
            --uic-charts-donut-chart-percentage-label-font-size,
            1rem
        );
    }

    &__label-datagroup-name {
        font-weight: var(
            --uic-charts-donut-chart-group-label-font-weight,
            normal
        );
        font-size: var(--uic-charts-donut-chart-group-label-font-size, 0.8rem);
    }

    &__label-datagroup-icon {
        font-size: var(--uic-charts-donut-chart-icon-label-size, 1.75em);
    }

    &__label-polyline {
        fill: none;
        stroke-width: 1;
        stroke: var(--uic-charts-donut-chart-text-color, black);
    }

    &__slice {
        fill: var(--uic-charts-data-group-color, black);
    }

    &__loading_indicator {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 100%;
        text-align: center;
        vertical-align: middle;

        background: var(--uic-charts-donut-chart-loading-overlay-color, white);
    }

    uic-loader {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: max(188px, 25%);
        text-align: center;
        vertical-align: middle;
    }

    &__no-data-indicator {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 100%;
    }
}
